import { Locale } from '@headless-workspace/config';
import { unwrapResultSuccess } from '@headless-workspace/core-domain';
import { CommonDI, PriceLegalMentionsRepositoryType } from '../../../../DI';

export async function isPriceExceptionLegalMentionsEnabled(locale: Locale): Promise<boolean> {
    const result = await CommonDI.get(PriceLegalMentionsRepositoryType).fetchEnablePriceLegalMentions(locale);
    return unwrapResultSuccess(result) ?? false;
}
